import i18n from "@/i18n";
import moment from "moment";

export default {
  namespaced: true,
  state: {
    language: "en",
    sidebar: {
      minimized: false
    },
    pageSize: 10,
    mfPageSize: 50,
    matchPageSize: 100,
    pageSizeOptions: [10, 20, 50, 100],
    mfPageSizeOptions: [50, 100, 200],
    matchPageSizeOptions: [10, 20, 50, 100, 200, 500, 1000],
    matchCache: {
      sport: 1,
      matchSearch: '',
      filterBy: 'league_name',
      market: '',
      linked: '',
      isLive: '',
      startDate: moment(new Date).add(-1, 'days').format('YYYY-MM-DD'),
      endDate: moment(new Date).format('YYYY-MM-DD')
    },
    mapMatchCache: {
      sport: 1,
      linked: "false",
      market: 'today',
      isBackup: "false",
      game: '',
      startDate: moment(new Date).add(-1, 'days').format('YYYY-MM-DD'),
      endDate: moment(new Date).format('YYYY-MM-DD')
    }
  },
  mutations: {
    updateLanguage(state, payload) {
      state.language = payload;
    },
    updateSidebarMinimized(state, payload) {
      state.sidebar.minimized = payload;
    },
    updatePageSize(state, payload) {
      state.pageSize = payload;
    },
    updateMFPageSize(state, payload) {
      state.mfPageSize = payload;
    },
    updateMatchPageSize(state, payload) {
      state.matchPageSize = payload;
    },
    updateMapMatchCache(state, payload) {
      state.mapMatchCache = payload;
    },
    updateMatchCache(state, payload) {
      state.matchCache = payload;
    }
  },
  actions: {
    setLanguage(context, payload) {
      i18n.locale = payload;
      context.commit("updateLanguage", payload);
    },
    setSidebarMinimized(context, payload) {
      context.commit("updateSidebarMinimized", payload);
    },
    setMatchPageSize(context, payload) {
      context.commit("updateMatchPageSize", payload);
    },
    setMFPageSize(context, payload) {
      context.commit("updateMFPageSize", payload);
    },
    setPageSize(context, payload) {
      context.commit("updatePageSize", payload);
    },
    setMapMatchCache(context, payload) {
      context.commit("updateMapMatchCache", payload);
    },
    setMatchCache(context, payload) {
      context.commit("updateMatchCache", payload);
    }
  }
};
